import {
  navSidebarBridge,
  NavSidebarBridgeApi,
} from './onboarding/services/nav-sidebar-bridge';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Directionality } from '@angular/cdk/bidi';
import {
  ChangeDetectorRef,
  Component,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
  effect,
  inject,
} from '@angular/core';
import { TerminalRouteLockService } from './modules/terminal/services/terminal-route-lock.service';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouterOutlet } from '@angular/router';
import { CommonModule, DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerComponent } from './core/components/spinner/spinner.component';
import { GlobalSpinnerService } from './core/services/loader/global-spinner.service';
import { DialogService } from './core/services/dialog/dialog.service';
import { FcmService } from './core/services/notification/fcm.service';
import { PushNotificationsService } from './core/services/notification/push-notifications.service';
import { PushNavigationService } from './core/services/notification/push-navigation.service';
import { UpdateService } from './core/services/pwa/update.service';
import { ForegroundRefreshService } from './core/services/pwa/foreground-refresh.service';
import { AuthService } from './modules/auth/services/auth/auth.service';
import { CompanySettingsService } from './modules/settings/services/company-settings.service';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { Observable, Subject, Subscription, combineLatest } from 'rxjs';
import { filter, takeUntil, distinctUntilChanged, map } from 'rxjs/operators';
import { TimeRecordingService } from './modules/time-recording/services/time-recording.service';
import {
  ActionPerformed,
  PushNotifications,
} from '@capacitor/push-notifications';
import { App } from '@capacitor/app';
import { StatusBar, Style as StatusBarStyle } from '@capacitor/status-bar';
import { LayoutMode } from './core/services/const';
import {
  MOBILE_ADMIN_COMPACT_CLASS,
  isMobileAdminCompact,
  mobileAdminHeaderHeightPx,
} from './core/layout/mobile-admin-compact';
import { XdsViewportService } from './shared/ui/a11y/viewport.service';
import { ThemeService } from './core/services/theme/theme.service';
import { UserSettingsService } from './modules/settings/user-settings/services/user-settings.service';
import { NavigationHistoryService } from './core/services/navigation-history.service';
import { SyncCoordinatorService } from './core/services/sync-coordinator.service';
import { DeepLinkHandlerService } from './core/services/deep-link/deep-link-handler.service';
import { MobileAdminRefreshService } from './core/services/mobile-admin-refresh.service';
import { UserPermissionsService } from './modules/employee/services/user-permissions.service';
import { AdminMobileHeaderComponent } from './navigation/admin-mobile-header/admin-mobile-header.component';
import { PageHeaderComponent } from './navigation/page-header/page-header.component';
import { TopActionsBarComponent } from './navigation/top-actions-bar/top-actions-bar.component';
import { PageHeaderTerminalComponent } from './navigation/page-header-terminal/page-header-terminal.component';
import { AdminSidebarComponent } from './navigation/admin-sidebar/admin-sidebar.component';
import { HelpHubComponent } from './help/help-hub/help-hub.component';
import { Splashscreen } from './core/components/splashscreen/splashscreen';
import { NetworkStatusBannerComponent } from './core/components/network-status-banner/network-status-banner.component';
import { TrialBannerComponent } from './core/components/trial-banner/trial-banner.component';
import { DemoBannerComponent } from './core/components/demo-banner/demo-banner.component';
import { PaymentWallDialogService } from './core/services/payment-wall/payment-wall-dialog.service';
import { PullToRefreshDirective } from './core/directives/pull-to-refresh.directive';
import { OnboardingNudgeComponent } from './onboarding/rendering/nudge/onboarding-nudge.component';
import { DemoTourResumeTabComponent } from './onboarding/rendering/demo-tour-resume-tab/demo-tour-resume-tab.component';
import { TriggerMatcher } from './onboarding/services/trigger-matcher.service';
import { TourStateStore } from './onboarding/services/tour-state-store.service';
import { TourCoordinator } from './onboarding/services/tour-coordinator.service';
import { ForgivingTourClickDelegator } from './onboarding/services/forgiving-tour-click-delegator.service';
import { LanguageService } from './core/services/language/language.service';
import { SubscriptionService } from './modules/feature-toggle/services/subscription.service';
import { Feature } from './modules/feature-toggle/enums/features.enum';
import { AudienceResolver } from './onboarding/services/audience-resolver.service';
import { Audience } from './onboarding/config/audience.enum';
import { employeeAreaCounterpart } from './modules/employee/desktop/shell/employee-area-counterpart';

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        RouterOutlet,
        SpinnerComponent,
        Splashscreen,
        AdminMobileHeaderComponent,
        PageHeaderComponent,
        TopActionsBarComponent,
        PageHeaderTerminalComponent,
        AdminSidebarComponent,
        NetworkStatusBannerComponent,
        TrialBannerComponent,
        DemoBannerComponent,
        PullToRefreshDirective,
        OnboardingNudgeComponent,
        DemoTourResumeTabComponent,
        HelpHubComponent
    ],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'FixPlaner';
  isMobile: boolean;
  currentUrl: string;
  isLoggedin: boolean;
  activeLayout: LayoutMode = LayoutMode.TOPBAR;
  public LayoutMode = LayoutMode;

  isEmployeeMobileTabsRoute: boolean = false;

  isMobileAdminView: boolean = false;
  // Pull-to-Refresh ist NICHT an die Mobile-Breite (isMobileAdminView) gekoppelt,
  // sonst greift der Swipe auf Tablets im Querformat (> 960px) nicht. Stattdessen:
  // Touch-/Native-Geraet + Admin-Kontext -> in beiden Orientierungen aktiv.
  isPullToRefreshEnabled: boolean = false;
  isMobileAdminSidebarOpen: boolean = false;

  /**
   * Geraeteklasse fuer den kompakten Rahmen (T1 „Rahmen-Diaet").
   *
   * Bewusst NICHT der CDK-Observer oben: der beobachtet `XSmall + Small` und feuert
   * beim Uebertritt 700 -> 600px gar nicht, weil beide Breiten im selben Bereich
   * liegen. Die Diaet-Grenze ist aber 640px — sie liegt mitten in `Small`. Ohne diese
   * zweite Quelle bliebe die Klasse beim Drehen eines 700-px-Fensters stehen.
   */
  private readonly viewport = inject(XdsViewportService);

  /** Push-Tap, Kaltstart-Ziel nach der Anmeldung, Glocken-Zähler. */
  private readonly pushNavigation = inject(PushNavigationService);

  /**
   * Haelt Body-Klasse und Kopfhoehe an der Geraeteklasse nach.
   *
   * Als Feld-Initialisierer, weil `effect()` einen Injection-Kontext braucht — in
   * `ngOnInit` waere er ohne `Injector` nicht erlaubt. Der Effekt selbst laeuft erst
   * nach der Komponenten-Erzeugung, die Konstruktor-Abhaengigkeiten (`renderer`,
   * `document`) sind zu diesem Zeitpunkt also gesetzt.
   */
  private readonly compactFrameEffect = effect(() => {
    // Lesen registriert die Abhaengigkeit — ohne diese Zeile laeuft der Effekt genau
    // einmal und der Rahmen bleibt beim Drehen auf dem alten Stand stehen.
    this.viewport.deviceClass();
    this.updateBodyClass();
    this.updateSidebarAndHeaderVariables();
  });

  globalSpinnerVisible$: Observable<boolean>;

  // Help-Hub nur zeigen, wenn die Firma das KI-Hilfe/FAQ-Feature hat.
  // Fail-open: solange Features noch nicht geladen sind, bleibt der Hub sichtbar
  // (er traegt auch das Onboarding) — erst nach geladenem Feature-Set wird gegated.
  hasHelpHub$: Observable<boolean>;

  private destroy$ = new Subject<void>();
  private appStateSubscription: Subscription;
  private visibilityChangeHandler: () => void;
  private focusHandler: () => void;

  constructor(
    private notificationService: PushNotificationsService,
    private updateService: UpdateService,
    public translate: TranslateService,
    public companySettingsService: CompanySettingsService,
    private userSettingsService: UserSettingsService,
    private userPermissionsService: UserPermissionsService,
    private fcmService: FcmService,
    private breakpointObserver: BreakpointObserver,
    public authService: AuthService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private dialogService: DialogService,
    private platform: Platform,
    _timeRecording: TimeRecordingService, // Injection startet beim App-Start den Abgleich der Offline-Stempel
    private foregroundRefresh: ForegroundRefreshService,
    private renderer: Renderer2,
    private zone: NgZone,
    private syncCoordinator: SyncCoordinatorService,
    private deepLinkHandler: DeepLinkHandlerService,
    private mobileAdminRefreshService: MobileAdminRefreshService,
    private themeService: ThemeService,
    private globalSpinnerService: GlobalSpinnerService,
    _navHist: NavigationHistoryService,
    _paymentWall: PaymentWallDialogService, // Injection triggers auto-subscription to isSuspended$
    _triggerMatcher: TriggerMatcher, // Injection startet Login-Subscribe fuer Welcome-Tour-Offers
    _forgivingDelegator: ForgivingTourClickDelegator, // Injection startet activeTour$-Subscribe + globalen Click-Listener
    private tourStateStore: TourStateStore,
    private tourCoordinator: TourCoordinator,
    private languageService: LanguageService,
    private subscriptionService: SubscriptionService,
    private audienceResolver: AudienceResolver,
    private directionality: Directionality,
    @Inject(DOCUMENT) private document: Document,
    terminalRouteLock: TerminalRouteLockService
  ) {
    this.globalSpinnerVisible$ = this.globalSpinnerService.visible$;

    // Im Konstruktor, nicht in ngOnInit: Die erste Navigation (Kaltstart, Deep-Link) muss
    // bereits unter der Sperre laufen.
    terminalRouteLock.start();

    // Help-Hub (Onboarding-Checkliste + KI-Assistent) ist eine reine
    // Admin-/Teamleiter-Flaeche: Er traegt den Setup-Funnel und den
    // Verwaltungs-Assistenten — fuer reine Mitarbeiter (Mobile-Tabs) ist er
    // weder zustaendig noch berechtigt. Daher rollen-gegated (fail-closed):
    // nur Admin (MANAGER) oder Teamleiter sehen den Button, unabhaengig von
    // Route oder Geraet. Die Audience leitet sich synchron aus den JWT-Rollen
    // ab, also ist fail-closed hier unbedenklich.
    const isManagerAudience$ = this.audienceResolver.currentAudience$.pipe(
      map(
        (audience) =>
          audience.includes(Audience.Admin) ||
          audience.includes(Audience.TeamLeader)
      ),
      distinctUntilChanged()
    );

    this.hasHelpHub$ = combineLatest([
      this.subscriptionService.featuresLoaded$,
      this.subscriptionService.hasFeature$(Feature.HELP_RAG_FAQ),
      isManagerAudience$,
    ]).pipe(
      // In einer Self-Service-Demo-Session bleibt der Help-Hub sichtbar: Der KI-Assistent ist
      // bewusst nutzbar (zum Anfuehlen), aber serverseitig auf ein KI-Kontingent gedeckelt
      // (DemoAiQuotaBehavior → HTTP 403 DEMO_AI_LIMIT_REACHED, prominenter Dialog). Frueher war er
      // in der Demo komplett ausgeblendet; das versteckte auch den nuetzlichen Onboarding-Funnel.
      map(([loaded, has, isManager]) => isManager && (!loaded || has))
    );

    // Sprache initialisieren — Single Source of Truth ist der LanguageService.
    // Er normalisiert Storage-Werte (z.B. legacy 'de-DE' → 'de') und ruft
    // `translate.use()` nur dann, wenn sich die Sprache aendert (idempotent).
    // Verhindert den Mixed-State, der vorher beim Mobile-Resize auftrat,
    // wenn diverse Header-Components RAW-Werte an `translate.use()` gaben.
    const stored =
      LanguageService.getStoredLanguage() ??
      LanguageService.normalize(navigator.language);
    this.languageService.applyLanguage(stored);

    // Set initial direction for language
    this.updateDirectionForLanguage(stored);

    const isNative = Capacitor.getPlatform() !== 'web';
    if (isNative) {
      this.fcmService.initPush();
    } else {
      this.notificationService.requestPermission();
    }
    this.updateService.checkForUpdates();

    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects;
        this.isEmployeeMobileTabsRoute =
          this.currentUrl.startsWith('/employee-mobile');

        const publicRoutes = [
          '/login',
          '/demo',
          '/registration',
          '/forgotpassword',
          '/resetpassword',
          '/reset-password',
          '/email-confirmation',
          '/change-password',
          '/accept-invitation',
          '/payment-confirmation',
          '/forbidden',
          // Kopplung eines neuen Terminals: ohne Anmeldung erreichbar, also darf die App hier
          // auch keine Firmeneinstellungen nachladen — der 401 daraus warf bis zum 13.09.2026
          // zur Anmeldung zurueck, noch bevor die Seite sichtbar wurde.
          '/terminal-pairing',
        ];

        const oldIsLoggedIn = this.isLoggedin;
        this.isLoggedin = !publicRoutes.some((route) =>
          this.currentUrl.startsWith(route)
        );

        if (oldIsLoggedIn !== this.isLoggedin) {
          if (this.isLoggedin) {
            // Terminals don't need User Settings or Permissions (they have no EmployeeId)
            // Use authService.isTerminal instead of local isTerminalUser() for better reliability
            if (!this.authService.isTerminal) {
              this.companySettingsService.getCompanySettings();
              this.userSettingsService.loadUserSettings();
              this.userPermissionsService.getCurrentUserPermissions();
              // Cross-Device-Resume: nach erfolgreichem Login pruefen, ob auf
              // einem anderen Geraet eine Tour pausiert wurde. loadAll wird
              // bereits vom AuthService gefeuert (fire-and-forget) — wir
              // awaiten hier explizit, damit der Cache gefuellt ist, bevor
              // checkResumableTours() ihn liest.
              void this.tourStateStore.loadAll().then(() =>
                this.tourCoordinator.checkResumableTours()
              );
            } else {
              // For terminals: Only load company settings (no user-specific data)
              this.companySettingsService.getCompanySettings();
            }
          } else {
            this.userSettingsService.clearUserSettings();
            this.userPermissionsService.clearPermissions();
            // Resume-Dialog-Flag zuruecksetzen, damit ein Re-Login im selben
            // Tab den Dialog wieder anzeigen darf.
            TourCoordinator.clearResumeDialogFlag();
          }
        }

        this.dialogService.setDialogOpen(
          this.currentUrl.includes('/registered-stepper')
        );

        this.updateMobileAdminViewStatus();
        this.updateLayout();
        this.applyDeviceRedirectOnce();
      });
  }

  /** Wurde die Geräteweiche in dieser Sitzung schon einmal ausgewertet? */
  private deviceRedirectChecked = false;

  /**
   * Führt die Geräteweiche EINMAL nach dem ersten Seitenwechsel aus.
   *
   * Bisher lief sie ausschliesslich bei einem Wechsel der Fensterklasse. Wer die
   * App direkt mit einem schmalen Fenster öffnete, bekam deshalb nie eine
   * Korrektur — ein Mitarbeiter landete auf der Desktop-Adresse, während die Shell
   * bereits „mobil" rechnete, und blieb dauerhaft ohne Kopfleiste und ohne
   * Abmelde-Weg. Umgekehrt sass jemand mit einem Lesezeichen auf die Ionic-Tabs
   * auf einem Vollbild-Schirm in einer Fläche, die dort nichts rendert.
   *
   * Beides sind stabile Fehlzustände: ohne Grössenänderung passiert nichts.
   */
  private applyDeviceRedirectOnce(): void {
    if (this.deviceRedirectChecked) return;
    if (!this.isLoggedin || this.isRegisteredStepperRoute()) return;

    this.deviceRedirectChecked = true;

    const targetUrl = this.determineTargetUrlBasedOnRoleAndDevice();
    if (targetUrl && this.router.url !== targetUrl) {
      // `navigateByUrl`: das Ziel kann einen Query-Teil tragen (`translateEmployeeArea`).
      void this.router.navigateByUrl(targetUrl);
    }
  }

  /**
   * Zugang zur Hauptnavigation fuer Tour-Configs (Demo-Verkaufsrundgang,
   * Station „Was gibt es sonst noch?"). Setzt ausschliesslich den
   * Bildschirmzustand — `activeLayout` wird hier NICHT ueber
   * `updateUserSettings` gespeichert, anders als beim Knopf in der Leiste
   * (`AdminSidebarComponent.toggleCompact`). Eine Tour zeigt etwas, sie aendert
   * keine Kontoeinstellung.
   */
  private readonly navSidebarBridgeApi: NavSidebarBridgeApi = {
    isPhoneLayout: () => this.isMobileAdminView,
    isMenuOpen: () => this.isMobileAdminView && this.isMobileAdminSidebarOpen,
    setMenuOpen: (open: boolean) => {
      if (!this.isMobileAdminView) return;
      if (this.isMobileAdminSidebarOpen === open) return;
      this.isMobileAdminSidebarOpen = open;
      this.updateLayout();
    },
    isCompact: () =>
      !this.isMobileAdminView && this.activeLayout === LayoutMode.COMPACT_SIDEBAR,
    setCompact: (compact: boolean) => {
      if (this.isMobileAdminView) return;
      // Nur zwischen den beiden Leisten-Bauformen schalten. Steht der Nutzer im
      // Topbar-Layout, gibt es keine Seitenleiste — dann waere „schmal" eine
      // Bauform, die er nie gewaehlt hat.
      if (
        this.activeLayout !== LayoutMode.SIDEBAR &&
        this.activeLayout !== LayoutMode.COMPACT_SIDEBAR
      ) {
        return;
      }
      this.activeLayout = compact
        ? LayoutMode.COMPACT_SIDEBAR
        : LayoutMode.SIDEBAR;
      this.updateLayout();
    },
  };

  ngOnInit() {
    navSidebarBridge.register(this.navSidebarBridgeApi);
    // Theme is now managed by ThemeService which handles:
    // - System theme detection (prefers-color-scheme)
    // - Auto/Light/Dark modes
    // - StatusBar updates for native platforms
    // ThemeService initializes itself on injection, so theme is already applied

    // Global Spinner bei Route-Transitions (Lazy-Loading-Feedback)
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        if (event instanceof NavigationStart) {
          this.globalSpinnerService.show();
        }
        if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.globalSpinnerService.hide();
        }
      });

    // Add platform classes for CSS targeting (safe-area, etc.)
    this.addPlatformClasses();

    // Initialize StatusBar overlay mode for native platforms
    this.initializeStatusBarOverlay();

    // Listen for language changes and update direction.
    // Normalisierung uebernimmt der LanguageService — event.lang ist schon
    // der kanonische Short-Code, aber wir defenden defensiv.
    this.translate.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe((event) => {
        this.updateDirectionForLanguage(LanguageService.normalize(event.lang));
      });

    // Set initial direction based on current (already normalized) language.
    const currentLang = this.languageService.getCurrentLanguage();
    this.updateDirectionForLanguage(currentLang);

    // Initial Check für Bildschirmgröße (synchron)
    this.isMobile = this.breakpointObserver.isMatched([Breakpoints.XSmall, Breakpoints.Small]);
    this.updateMobileAdminViewStatus();

    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        this.zone.run(() => {
          const oldIsMobile = this.isMobile;
          this.isMobile = result.matches;
          this.updateMobileAdminViewStatus();

          if (oldIsMobile !== this.isMobile) {
            if (this.isMobileAdminSidebarOpen && !this.isMobileAdminView) {
              this.isMobileAdminSidebarOpen = false;
            }
            if (this.isLoggedin && !this.isRegisteredStepperRoute()) {
              const targetUrl = this.determineTargetUrlBasedOnRoleAndDevice();
              if (targetUrl && this.router.url !== targetUrl) {
                void this.router.navigateByUrl(targetUrl);
              }
            }
          }
          this.updateLayout();
        });
      });

    // Layout aus UserSettings laden
    this.userSettingsService.currentUserSettings$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((settings) => {
      let newLayout = LayoutMode.TOPBAR;
      if (settings?.ActiveLayout) {
        newLayout = settings.ActiveLayout as LayoutMode;
      }
      if (this.activeLayout !== newLayout) {
        this.activeLayout = newLayout;
        this.updateLayout();
      }
    });

    // Initial layout from snapshot
    const currentUserSettings = this.userSettingsService.getCurrentUserSettingsSnapshot();
    if (currentUserSettings?.ActiveLayout) {
      this.activeLayout = currentUserSettings.ActiveLayout as LayoutMode;
      this.updateMobileAdminViewStatus();
      this.updateLayout();
    }

    this.dialogService.dialogOpen$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen) => {
        const navbar = this.document.querySelector('.navbar.navbar-default');
        if (navbar) {
          if (isOpen) this.renderer.addClass(navbar, 'navbar-disabled');
          else this.renderer.removeClass(navbar, 'navbar-disabled');
        }
      });

    this.initializeAppStateListeners();
    this.initializeSyncCoordinator();
    this.initializeDeepLinkHandler();
  }

  /**
   * Initialize deep link handler for email button links.
   * This enables:
   * - Web: Standard URL navigation
   * - Android: App Links (verified deep links)
   * - iOS: Universal Links
   */
  private initializeDeepLinkHandler(): void {
    this.deepLinkHandler.initialize().then(() => {
    }).catch((error) => {
      console.warn('[AppComponent] Failed to initialize deep link handler:', error);
    });

    // Process pending deep link or push notification target after successful login
    this.authService.authState$
      ?.pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          // Delay slightly to ensure navigation is complete
          setTimeout(() => {
            this.deepLinkHandler.processPendingDeepLink();
            this.processPendingPushNavigation();
          }, 500);
        }
      });
  }

  private processPendingPushNavigation(): void {
    this.pushNavigation.processPending();
  }

  private updateDirectionForLanguage(lang: string): void {
    const htmlElement = this.document.documentElement;
    const isRtl = lang === 'ar';
    const dir: 'rtl' | 'ltr' = isRtl ? 'rtl' : 'ltr';

    if (isRtl) {
      htmlElement.setAttribute('dir', 'rtl');
      htmlElement.setAttribute('lang', 'ar');
      this.document.body.classList.add('rtl-mode');
    } else {
      htmlElement.setAttribute('dir', 'ltr');
      htmlElement.setAttribute('lang', lang);
      this.document.body.classList.remove('rtl-mode');
    }

    // CDK-Directionality synchron halten. Sie liest `dir` nur EINMAL bei der
    // Konstruktion (Initialwert kommt aus dem Pre-Boot-`<html dir>`); `value`
    // ist getter-only und wird aus `valueSignal` abgeleitet. Beim Laufzeit-
    // Sprachwechsel (de↔ar ueber den Header) setzen wir das Signal — dadurch
    // oeffnen neue Overlays (mat-dialog, mat-menu, mat-select) sofort in der
    // richtigen Richtung und bereits offene Material-Komponenten reagieren.
    if (this.directionality.value !== dir) {
      this.directionality.valueSignal.set(dir);
    }
  }

  /**
   * Initialize StatusBar overlay mode for Capacitor native platforms (Android/iOS)
   * This configures the status bar for edge-to-edge display.
   * Theme-based styling is handled by ThemeService.
   */
  private async initializeStatusBarOverlay(): Promise<void> {
    // Only run StatusBar configuration on native platforms (Android/iOS)
    if (!Capacitor.isNativePlatform()) {
      return;
    }

    try {
      // On Android, set overlay to true so content renders behind status bar
      // This enables proper safe-area-inset-top CSS functionality
      if (Capacitor.getPlatform() === 'android') {
        await StatusBar.setOverlaysWebView({ overlay: true });

        // Set status bar background to match the header gradient for a polished look.
        // This prevents content from bleeding through the status bar when scrolling.
        await StatusBar.setBackgroundColor({ color: '#0095cc' });
      }

      // On iOS, overlay is typically the default behavior with viewport-fit=cover
      // But we ensure it's set correctly
      if (Capacitor.getPlatform() === 'ios') {
        await StatusBar.setOverlaysWebView({ overlay: true });
      }

    } catch (error) {
      // StatusBar plugin might not be available in some environments
      console.warn('[StatusBar] Failed to initialize overlay:', error);
    }
  }

  /**
   * Add platform-specific CSS classes to the HTML element
   * This allows CSS to target specific platforms (Android, iOS, Capacitor)
   * These classes are essential for safe-area-inset CSS rules to work
   */
  private addPlatformClasses(): void {
    const htmlElement = this.document.documentElement;
    const platform = Capacitor.getPlatform();

    // Add Capacitor class if running in a native container
    if (Capacitor.isNativePlatform()) {
      htmlElement.classList.add('plt-capacitor');
    }

    // Add platform-specific class
    if (platform === 'android') {
      htmlElement.classList.add('plt-android');
      htmlElement.classList.add('plt-mobile');
    } else if (platform === 'ios') {
      htmlElement.classList.add('plt-ios');
      htmlElement.classList.add('plt-mobile');
    } else if (platform === 'web') {
      htmlElement.classList.add('plt-web');

      // For PWA on mobile browsers, try to detect mobile
      if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        htmlElement.classList.add('plt-mobileweb');

        // Add specific mobile web platform classes
        if (/Android/i.test(navigator.userAgent)) {
          htmlElement.classList.add('plt-android');
        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
          htmlElement.classList.add('plt-ios');
        }
      }
    }

  }

  /**
   * @deprecated Use ThemeService.setThemeMode() instead.
   * StatusBar styling is now handled by ThemeService.
   */
  public async updateStatusBarStyle(isDarkMode: boolean): Promise<void> {
    // Delegated to ThemeService - this method is kept for backwards compatibility
    console.warn('[AppComponent] updateStatusBarStyle is deprecated. Use ThemeService instead.');
  }

  private initializeSyncCoordinator(): void {
    if (this.authService.isAuthenticated()) {
      this.startSyncCoordinator();
    }

    this.authService.authState$
      ?.pipe(takeUntil(this.destroy$), distinctUntilChanged())
      .subscribe((isAuthenticated) => {
        if (isAuthenticated) {
          this.startSyncCoordinator();
        } else {
          this.stopSyncCoordinator();
        }
      });

    window.addEventListener(
      'configuration-synced',
      this.handleConfigurationSync
    );
    window.addEventListener('sync-error', this.handleSyncError);
  }

  private startSyncCoordinator(): void {
    const status = this.syncCoordinator.getStatus();
    if (!status.isActive) {
      this.syncCoordinator.start();

      // Terminals don't have permissions
      // Use authService.isTerminal instead of local isTerminalUser() for better reliability
      if (!this.authService.isTerminal) {
        this.userPermissionsService.getCurrentUserPermissions();
      }
    }
  }

  private stopSyncCoordinator(): void {
    this.syncCoordinator.stop();
  }

  private handleConfigurationSync = (event: CustomEvent) => {
    if (event.detail.changes?.includes('CompanySettings')) {
      this.zone.run(() => {
        this.cdr.detectChanges();
      });
    }

    if (event.detail.changes?.includes('UserPermissions')) {
      this.zone.run(() => {
        // Terminals don't have permissions
        // Use authService.isTerminal instead of local isTerminalUser() for better reliability
        if (!this.authService.isTerminal) {
          this.userPermissionsService.getCurrentUserPermissions();
        }
        this.cdr.detectChanges();
      });
    }
  };

  private handleSyncError = (event: CustomEvent) => {
    // Nur als Warnung loggen, da dies ein normaler Zustand bei Offline-Nutzung sein kann
    console.warn('AppComponent: Configuration sync temporarily unavailable', event.detail);
    // Optional: Zeige eine Benachrichtigung an, wenn gewünscht
    // this.toastr.warning('Configuration sync temporarily unavailable', 'Sync Status');
  };

  private updateMobileAdminViewStatus(): void {
    this.isMobileAdminView = !!(
      this.isMobile &&
      this.isLoggedin &&
      this.authService.isManegeOrTeamLeader &&
      !this.authService.isTerminal &&
      !this.isRegisteredStepperRoute() &&
      !this.isEmployeeMobileTabsRoute
    );

    // Pull-to-Refresh: wie isMobileAdminView, aber OHNE die Breiten-Bedingung.
    // Gating auf Touch-/Native-Geraet, damit der Swipe auf Tablets in JEDER
    // Orientierung funktioniert, auf Desktop (Maus) aber nicht stoert.
    const isTouchDevice =
      Capacitor.isNativePlatform() ||
      (typeof window !== 'undefined' &&
        window.matchMedia?.('(pointer: coarse)').matches);
    this.isPullToRefreshEnabled = !!(
      isTouchDevice &&
      this.isLoggedin &&
      this.authService.isManegeOrTeamLeader &&
      !this.authService.isTerminal &&
      !this.isRegisteredStepperRoute() &&
      !this.isEmployeeMobileTabsRoute
    );
  }

  toggleAdminMobileSidebar(): void {
    if (this.isMobileAdminView) {
      this.isMobileAdminSidebarOpen = !this.isMobileAdminSidebarOpen;
      this.updateLayout();
    }
  }

  private updateLayout(): void {
    this.updateBodyClass();
    this.updateSidebarAndHeaderVariables();

    setTimeout(() => {
      this.zone.run(() => {
        this.cdr.detectChanges();
      });
    }, 0);
  }

  /**
   * Übersetzt die aktuelle Adresse in ihr Gegenstück auf der anderen Geräteklasse — samt
   * Query-Teil (Glocken-/Push-Ziele, P4, 17.10.2026). Tabelle und Regel:
   * `employeeAreaCounterpart`. `null`, wenn es keines gibt — dann greift die grobe Weiche darunter.
   * Die Aufrufer navigieren mit `navigateByUrl` (ein `?` in `navigate([...])` würde als Pfad kodiert).
   */
  private translateEmployeeArea(toMobile: boolean): string | null {
    return employeeAreaCounterpart(this.currentUrl, toMobile);
  }

  private determineTargetUrlBasedOnRoleAndDevice(): string | null {
    const isNormalEmployee =
      !this.authService.isManegeOrTeamLeader && !this.authService.isTerminal;

    if (this.isMobile) {
      if (isNormalEmployee) {
        if (!this.currentUrl.startsWith('/employee-mobile')) {
          // Erst das genaue Gegenstück versuchen, sonst die Startseite.
          return this.translateEmployeeArea(true) ?? '/employee-mobile';
        }
      } else if (
        this.authService.isManegeOrTeamLeader &&
        !this.authService.isTerminal
      ) {
        if (this.currentUrl.startsWith('/employee-mobile')) return '/dashboard';
      } else if (this.authService.isTerminal) {
        if (!this.currentUrl.startsWith('/terminal-dashboard'))
          return '/terminal-dashboard';
      }
    } else {
      if (isNormalEmployee) {
        if (this.currentUrl.startsWith('/employee-mobile')) {
          return this.translateEmployeeArea(false) ?? '/employeedashboard';
        }
      } else if (
        this.authService.isManegeOrTeamLeader &&
        !this.authService.isTerminal
      ) {
        if (this.currentUrl.startsWith('/employee-mobile')) return '/dashboard';
      } else if (this.authService.isTerminal) {
        if (!this.currentUrl.startsWith('/terminal-dashboard'))
          return '/terminal-dashboard';
      }
    }
    return null;
  }

  /**
   * Gilt der kompakte Rahmen? Reine Ableitung, damit Template, Body-Klasse und
   * Kopfhoehe **dieselbe** Quelle benutzen und nicht drei Bedingungen pflegen.
   */
  isMobileAdminCompact(): boolean {
    return isMobileAdminCompact(
      this.isMobileAdminView,
      this.viewport.deviceClass()
    );
  }

  private updateBodyClass(): void {
    const body = this.document.body;
    Object.values(LayoutMode).forEach((mode) =>
      this.renderer.removeClass(body, `layout-${mode}`)
    );
    this.renderer.removeClass(body, 'layout-public');
    this.renderer.removeClass(body, 'layout-mobile-tabs');
    this.renderer.removeClass(body, 'layout-mobile-admin');
    this.renderer.removeClass(body, MOBILE_ADMIN_COMPACT_CLASS);
    this.renderer.removeClass(body, 'mobile-admin-sidebar-open');

    if (this.isLoggedin && !this.isRegisteredStepperRoute()) {
      if (this.isMobileAdminView) {
        this.renderer.addClass(body, 'layout-mobile-admin');
        // Zweite, ENGERE Klasse fuer die Rahmen-Diaet: die Huelle gilt bis 959,98px,
        // die Diaet nur bis 639,98px. Begruendung in mobile-admin-compact.ts.
        if (this.isMobileAdminCompact()) {
          this.renderer.addClass(body, MOBILE_ADMIN_COMPACT_CLASS);
        }
        if (this.isMobileAdminSidebarOpen) {
          this.renderer.addClass(body, 'mobile-admin-sidebar-open');
        }
      } else if (this.isMobile && this.isEmployeeMobileTabsRoute) {
        this.renderer.addClass(body, 'layout-mobile-tabs');
      } else if (this.isMobile) {
        // Fallback
      } else {
        if (
          this.authService.isManegeOrTeamLeader &&
          !this.authService.isTerminal
        ) {
          this.renderer.addClass(body, `layout-${this.activeLayout}`);
        } else {
          this.renderer.addClass(body, `layout-${LayoutMode.TOPBAR}`);
        }
      }
    } else {
      this.renderer.addClass(body, 'layout-public');
    }
  }

  private updateSidebarAndHeaderVariables(): void {
    let sidebarWidthCssVar = '0px';
    let headerHeightCssVar = '0px';
    let mobileAdminHeaderHeightCssVar = '0px';

    if (this.isPublicOrStepperRoute()) {
      sidebarWidthCssVar = '0px';
      headerHeightCssVar = '0px';
      mobileAdminHeaderHeightCssVar = '0px';
    } else if (this.isMobileAdminView) {
      sidebarWidthCssVar = '0px';
      // 48px am Telefon (Rahmen-Diaet), 56px auf Tablets. Der Wert bleibt bewusst ein
      // reines px-Literal — s. mobileAdminHeaderHeightPx().
      mobileAdminHeaderHeightCssVar = mobileAdminHeaderHeightPx(
        this.isMobileAdminCompact()
      );
      headerHeightCssVar = mobileAdminHeaderHeightCssVar;
    } else {
      if (this.shouldShowAdminSidebarDesktop()) {
        sidebarWidthCssVar =
          this.activeLayout === LayoutMode.COMPACT_SIDEBAR
            ? 'var(--sidebar-width-compact)'
            : 'var(--sidebar-width-default)';
      } else {
        sidebarWidthCssVar = '0px';
      }

      if (this.shouldShowDesktopHeader()) {
        headerHeightCssVar = '55px';
      } else if (this.shouldShowTopActionsBar()) {
        headerHeightCssVar = '55px';
      } else {
        headerHeightCssVar = '0px';
      }
    }

    this.document.documentElement.style.setProperty(
      '--current-sidebar-width',
      sidebarWidthCssVar
    );
    this.document.documentElement.style.setProperty(
      '--actual-header-height',
      headerHeightCssVar
    );
    this.document.documentElement.style.setProperty(
      '--mobile-admin-header-height',
      mobileAdminHeaderHeightCssVar
    );
  }

  /**
   * Handle pull-to-refresh in mobile admin views.
   * Triggers a refresh across all subscribed page components via the MobileAdminRefreshService.
   * Each page component is responsible for its own refresh logic.
   */
  handleMobileAdminRefresh(): void {
    // Trigger refresh for all subscribed page components
    // Each page (Dashboard, Shifts-Planner, Availability, etc.) handles its own data refresh
    this.mobileAdminRefreshService.triggerRefresh();

    // Refresh company settings (safe for admin context)
    this.companySettingsService.getCompanySettings();
  }

  initializeAppStateListeners() {
    this.platform.ready().then(() => {
      if (Capacitor.getPlatform() !== 'web') {
        App.addListener('appStateChange', (state) => {
          if (state.isActive) {
            // Re-check system dark mode (handles OS theme change while app was in background)
            this.themeService.handleAppResume();
            this.foregroundRefresh.onNativeResume(this.isLoggedin);
          } else {
            this.foregroundRefresh.markBackground();
          }
        });
        PushNotifications.addListener(
          'pushNotificationActionPerformed',
          async (notification: ActionPerformed) => {
            // Angemeldet: sofort zu `navigateTo` (samt `?comment=`); Kaltstart: merken und nach
            // der Anmeldung nachholen (`processPendingPushNavigation`). Danach Glocke auffrischen.
            this.pushNavigation.handleTap(
              notification.notification?.data,
              this.isLoggedin
            );
            this.foregroundRefresh.onPushTap(this.isLoggedin);
          }
        );
      }

      // Ob nachgeladen wird, entscheidet `ForegroundRefreshService` — auf einem Terminal nie.
      this.visibilityChangeHandler = () => {
        if (this.document.hidden) {
          this.foregroundRefresh.markBackground();
        } else {
          this.foregroundRefresh.onBrowserVisible(this.isLoggedin);
        }
      };

      this.focusHandler = () => {
        this.foregroundRefresh.onBrowserFocus(this.isLoggedin);
      };

      this.document.addEventListener(
        'visibilitychange',
        this.visibilityChangeHandler
      );
      window.addEventListener('focus', this.focusHandler);
    });
  }

  isRegisteredStepperRoute(): boolean {
    return !!this.currentUrl?.includes('/registered-stepper');
  }

  shouldShowAdminSidebarDesktop(): boolean {
    return (
      !this.isMobile &&
      this.isLoggedin &&
      this.authService.isManegeOrTeamLeader &&
      !this.authService.isTerminal &&
      !this.isRegisteredStepperRoute() &&
      (this.activeLayout === LayoutMode.SIDEBAR ||
        this.activeLayout === LayoutMode.COMPACT_SIDEBAR)
    );
  }

  shouldShowAdminSidebarComponent(): boolean {
    return this.isMobileAdminView || this.shouldShowAdminSidebarDesktop();
  }

  /**
   * Liegt die aktuelle Adresse in der Mitarbeiter-Desktop-Hülle?
   *
   * `EmployeeShellComponent` (`modules/employee/desktop/shell/`) bringt ihre eigene
   * Kopfleiste mit — randlos, klebend, mit eigener Breitenbegrenzung — und bettet
   * `<app-top-actions-bar [compact]="true">` selbst in deren Werkzeug-Bereich ein.
   * Alles, was die App-Shell sonst oben beisteuert, muss auf diesen Routen
   * schweigen: sonst stünden zwei Kopfzeilen übereinander (bei Vorgesetzten, die
   * ihre eigenen Zeiten ansehen) und der Inhalt läge im `.container-fluid` mit
   * 30px Innenabstand, wo die Leiste nicht mehr randlos kleben kann.
   */
  private isEmployeeShellRoute(): boolean {
    const url = this.currentUrl;
    if (!url) return false;
    return url === '/employee/dashboard' || url.startsWith('/employee/dashboard/');
  }

  shouldShowTopActionsBar(): boolean {
    if (!this.isLoggedin || this.isRegisteredStepperRoute()) {
      return false;
    }

    if (this.authService.isTerminal) {
      return true;
    }

    if (this.isMobile) {
      return false;
    }

    if (this.isEmployeeShellRoute()) {
      return false;
    }

    if (
      this.authService.isManegeOrTeamLeader &&
      (this.activeLayout === LayoutMode.SIDEBAR ||
        this.activeLayout === LayoutMode.COMPACT_SIDEBAR)
    ) {
      return true;
    }

    if (!this.authService.isManegeOrTeamLeader) {
      return true;
    }

    return false;
  }

  /**
   * Wie `shouldShowTopActionsBar()`, aber ohne Terminal — Terminal hat mit
   * `app-page-header-terminal` bereits einen eigenen Header (sonst würden
   * beide Header für Terminal-Desktop-User gleichzeitig rendern).
   */
  /**
   * Seiten, die die Controls bereits selbst im `xdsPageActions`-Slot ihres
   * eigenen `xds-page-header` einbetten (siehe jeweilige Component) — dort
   * würde die App-Shell-Leiste sonst ein zweites Mal dieselben Controls zeigen.
   *
   * ⚠️ Der Präfix `'/employee'` deckt per `startsWith` ZWEI Fälle ab, und beide
   * betten inzwischen wirklich ein:
   *   - `/employee` → Mitarbeiterliste der Vorgesetzten (`employee.component.html`)
   *   - `/employee/dashboard/*` → Mitarbeiter-Desktop-Hülle (`employee-topbar.component.html`)
   * Für den zweiten Fall war der Eintrag lange eine stille Zusage ohne Deckung:
   * die Shell hielt sich zurück, die Seite lieferte nichts nach — und ein
   * Mitarbeiter kam nicht mehr aus seiner Sitzung heraus. Wer hier etwas ändert,
   * muss beide Flächen prüfen.
   */
  private readonly routesWithEmbeddedTopActionsBar: readonly string[] = [
    '/time-recording',
    '/availability',
    '/planner',
    '/tasks',
    '/employee',
    '/dashboard',
    '/absence',
    '/organization',
    '/settings',
  ];

  private isRouteWithEmbeddedTopActionsBar(): boolean {
    const url = this.currentUrl;
    if (!url) return false;
    return this.routesWithEmbeddedTopActionsBar.some(
      (prefix) => url === prefix || url.startsWith(prefix + '/') || url.startsWith(prefix + '?')
    );
  }

  shouldShowInlineTopActionsBar(): boolean {
    return (
      this.shouldShowTopActionsBar() &&
      !this.authService.isTerminal &&
      !this.isRouteWithEmbeddedTopActionsBar()
    );
  }

  shouldShowDesktopHeader(): boolean {
    return (
      !this.isMobile &&
      this.isLoggedin &&
      !this.authService.isTerminal &&
      !this.isRegisteredStepperRoute() &&
      // Ein Vorgesetzter, der seine eigenen Zeiten ansieht, bekommt sonst die
      // Admin-Kopfzeile UND die Mitarbeiter-Kopfleiste übereinander.
      !this.isEmployeeShellRoute() &&
      this.authService.isManegeOrTeamLeader &&
      this.activeLayout === LayoutMode.TOPBAR
    );
  }

  ngOnDestroy(): void {
    navSidebarBridge.unregister(this.navSidebarBridgeApi);
    this.syncCoordinator.stop();
    window.removeEventListener(
      'configuration-synced',
      this.handleConfigurationSync
    );
    window.removeEventListener('sync-error', this.handleSyncError);

    this.destroy$.next();
    this.destroy$.complete();
    if (this.appStateSubscription) this.appStateSubscription.unsubscribe();
    if (this.visibilityChangeHandler)
      this.document.removeEventListener(
        'visibilitychange',
        this.visibilityChangeHandler
      );
    if (this.focusHandler)
      window.removeEventListener('focus', this.focusHandler);
    PushNotifications.removeAllListeners();
  }

  isPublicOrStepperRoute(): boolean {
    return !this.isLoggedin || this.isRegisteredStepperRoute();
  }

  isEmployeeProfileRoute(): boolean {
    return this.router.url.includes('/employee-mobile/profile');
  }

  isUserSettingsRoute(): boolean {
    return this.router.url.includes('/user-settings');
  }

  getMainContentPaddingTop(): string {
    if (this.isEmployeeProfileRoute() || this.isUserSettingsRoute()) {
      return '0px';
    }

    // Der Mobile-Admin-Abstand kommt seit 2026-09-04 aus app.component.css, NICHT
    // mehr von hier. Vorher stand dieselbe Regel an ZWEI Orten — und sie waren nie
    // deckungsgleich: das Inline-Style rechnete die Safe-Area mit, das CSS nicht.
    // Solange das Inline-Style gewann, fiel das nicht auf; es war eine stille
    // Zeitbombe fuer jeden Moment, in dem es fehlt. Jetzt gibt es eine Quelle, und sie
    // traegt die Safe-Area. Der 0px-Zweig oben bleibt inline, weil Inline-Styles die
    // CSS-Regel ueberstimmen muessen.

    if (this.isPublicOrStepperRoute()) {
      return '0px';
    }

    return null;
  }

  isSettingsRoute(): boolean {
    return this.currentUrl?.startsWith('/settings');
  }

  isOrganizationRoute(): boolean {
    return this.currentUrl?.startsWith('/organization');
  }

  getMainContentClasses(): { [key: string]: boolean } {
    return {
      'ionic-content': this.isEmployeeMobileTabsRoute,
      'settings-active': this.isSettingsRoute(),
      'organization-active': this.isOrganizationRoute(),
    };
  }

  shouldHaveNoTopPadding(): boolean {
    return (
      this.isRegisteredStepperRoute() ||
      (this.isMobile && this.isEmployeeMobileTabsRoute) ||
      (this.isMobile &&
        !this.authService.isManegeOrTeamLeader &&
        !this.authService.isTerminal &&
        !this.isEmployeeMobileTabsRoute &&
        !this.isMobileAdminView) ||
      (!this.isMobile &&
        this.isLoggedin &&
        (this.activeLayout === LayoutMode.SIDEBAR ||
          this.activeLayout === LayoutMode.COMPACT_SIDEBAR) &&
        !this.shouldShowTopActionsBar())
    );
  }

  shouldUseContainerFluid(): boolean {
    // Die Mitarbeiter-Hülle setzt ihren Innenabstand selbst und braucht die volle
    // Fensterbreite, damit die Kopfleiste randlos kleben kann. Bewusst NICHT über
    // die Liste unten gelöst: die prüft `startsWith`, und ein Eintrag `'/employee'`
    // würde die Mitarbeiterliste der Vorgesetzten mit erwischen.
    if (this.isEmployeeShellRoute()) {
      return false;
    }

    const noContainerRoutes = [
      '/employee-mobile',
      '/user-settings',
      '/employee-mobile/profile',
    ];

    const isSpecialRoute = noContainerRoutes.some((route) =>
      this.currentUrl?.startsWith(route)
    );

    return !isSpecialRoute && !this.isPublicOrStepperRoute();
  }
}
